

















import { Component, Vue } from 'vue-property-decorator'
import { Meta } from '@/helpers/decorators'

@Component
export default class Company extends Vue {
  @Meta
  metas() {
    return {
      title: this.$t('menu.company'),
      titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
    }
  }
}
